/*import { ReactComponent as GM8 } from '../../resources/icon/devices/GM8.svg';
import { ReactComponent as GM50 } from '../../resources/icon/devices/GM50.svg';
import { ReactComponent as GM75 } from '../../resources/icon/devices/GM75.svg';
import { ReactComponent as GM85 } from '../../resources/icon/devices/GM85.svg';
import { ReactComponent as GM100 } from '../../resources/icon/devices/GM100.svg';
import { ReactComponent as GM2000 } from '../../resources/icon/devices/GM2000.svg';
import { ReactComponent as MachineDefault } from '../../resources/icon/machine.svg';*/

export const getDeviceImage = (device: any) => {
    const useName = device
        ? device.MachineType && device.MachineType.Name
            ? device.MachineType.Name
            : device
        : '';
    /*switch (useName) {
        case 'GM8':
            return GM8;
        case 'GM50':
        case 'GM65':
            return GM50;
        case 'GM75':
            return GM75;
        case 'GM85':
            return GM85;
        case 'GMe100':
        case 'GM100':
        case 'GM200':
            return GM100;
        case 'GM2000':
            return GM2000;
        default:
            return MachineDefault;
    }*/
};

export const getOperatingHourMetric = (asset: any) => {
    const operatingHourEntries = [...asset.OperationHours];
    operatingHourEntries.sort((a, b) => new Date(b.Date).getTime() - new Date(a.Date).getTime());
    const operatingHourEntry =
        operatingHourEntries.length > 0 ? operatingHourEntries[0] : undefined;

    return operatingHourEntry;
};
